import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-4 mt-8 border-t border-gray-200 bg-white/50 dark:bg-gray-900/50 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            © {currentYear} WeaveIn.ai by Trust. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm">
            <Link
              to="/consent/terms-of-use"
              className="text-gray-600 dark:text-gray-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors"
            >
              Terms of Service
            </Link>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <a
              href="/privacy-policy.html"
              className="text-gray-600 dark:text-gray-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors"
            >
              Privacy Policy
            </a>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <Link
              to="/sms-opt-in"
              className="text-gray-600 dark:text-gray-400 hover:text-teal-600 dark:hover:text-teal-400 transition-colors"
            >
              Text Alerts
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
